import { useQuery } from '@tanstack/react-query';
import { listOpenDrafts, type DraftState } from './api';

/**
 * Caiet §4.2 — nav items that need operator attention are demarcated.
 * For Stock reporting, "Rapoarte nefinalizate" (open drafts) is the signal.
 * Re-fetches lazily; consumers (sidebar, the Acasă band) read the same query.
 *
 * A draft with no rows is left out (spec 054 FR-023, research R7): visiting
 * "Raport nou" must not raise the count.
 */
export function useDraftsCount(enabled: boolean): {
  count: number;
  drafts: DraftState[];
  isLoading: boolean;
} {
  const q = useQuery({
    queryKey: ['drafts-count'],
    queryFn: listOpenDrafts,
    enabled,
    staleTime: 15_000,
  });
  const drafts = q.data ?? [];
  return { count: drafts.length, drafts, isLoading: q.isLoading };
}
